<script setup lang="ts">
    import type { BikesCollectionData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    /**
     * Products Widget Container
     * loads a collection via the api and renders a set of cards for each product
     * while loading the collection, a skeleton should be rendered
     * we only fetch the first collection in the array
     */
    const props = defineProps<IWidgetProps<BikesCollectionData>>();
    const { data } = useWidget(props);
    const { country, language } = useLocales();
    const { resolveUrlLink } = useURL();

    const collectionId = `${country.value}:${language.value}:collection:${props.data.handle}`;
    const { data: products } = useProductCollection(collectionId);

    const title = computed(() => {
        return props.data?.intro?.title;
    });
    const description = computed(() => {
        return props.data?.intro?.subtitle;
    });
    const bgColor = computed(() => {
        return props.data?.style?.background_color;
    });
    const bg = computed(() => {
        return props.data?.style?.backgroundimage;
    });
    const linkText = computed(() => {
        return props.data?.link?.label ?? '';
    });
    const linkUrl = computed(() => {
        const { url } = resolveUrlLink(props.data?.link);
        return url;
    });
</script>
<template>
    <org-carousel
        v-if="products?.length"
        :products="products"
        :link="linkUrl"
        :link-text="linkText"
        :title="title"
        :color-filter="data.filter"
        :background-color="bgColor"
        :background-image="bg"
        :description="description">
    </org-carousel>
</template>
